export default __webpack_public_path__ + "static/media/Best_Buy-Logo.wine.7107b2bf.png";